<template>
  <div class="comments-section">
    <div class="field">
      <label class="label">
        <i class="fa fa-comments mr-2"></i>
        {{ $t("evaluation comments") }}
      </label>
      <div class="control">
        <div class="comment-box">
          <div class="content">
            <p>{{ comments }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommentsSection",

  props: {
    comments: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.comments-section {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid hsl(0, 0%, 42%);
}

.comment-box {
  background-color: hsl(0, 0%, 14%);
  border: 1px solid hsl(0, 0%, 29%);
  border-radius: 6px;
  padding: 1rem;
  min-height: 80px;
}

.comment-box .content p {
  margin-bottom: 0;
  line-height: 1.6;
  white-space: pre-wrap;
  color: hsl(0, 0%, 96%);
}

.label {
  font-weight: 600;
  color: hsl(0, 0%, 96%) !important;
}

.mr-2 {
  margin-right: 0.5rem;
}
</style>
